module.exports = __webpack_public_path__ + "img/ship.2e53b5ba.svg";